import React, { useEffect, useState } from 'react';
import api from '../../utils/axiosConfig';
import PreLoader from '../../Loader/PreLoader';
import NoDataFoundLayout from '../../layouts/NoDataFoundLayout';
import { formatDateTime } from '../../helper/utils';
import { getYearMonthName } from '../../helper/utils';
import Swal from 'sweetalert2';

const HostelBills = () => {
      const [hostelBills, setHostelBills] = useState([]);
      const [loading, setLoading] = useState(true);


    useEffect(()=> {
      const fetchHostelBills = async () => {
        const studentUid = sessionStorage.getItem('student_uid');

        if (!studentUid) {
          Swal.fire({
            title: 'Error',
            text: 'Student UID not found in session storage. Please login again.',
            icon: 'error',
          });
          setLoading(false);
          return;
        }

        try {
          const response = await api.get(`/view-hostel-bills/${studentUid}`);
          setHostelBills(response.data);
        } catch (error) {
          console.error('Error fetching hostel bills data:', error);
          setHostelBills([]);
        } finally {
          setLoading(false);
        }
      };

      fetchHostelBills();
  }, [])


const handleDownloadHostelUtilityReceipt = async (transactionId) => {
  try {
    const response = await api.post(`/download-hostel-utility-receipt/${transactionId}`, {}, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Receipt-${transactionId}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Failed to download receipt:', error);
    alert('Failed to download receipt. Please try again.');
  }
};


    if (loading) return <PreLoader />;
    if (!hostelBills || hostelBills.length === 0)
    return <NoDataFoundLayout errorCaption="No Payment Hostel Utils Bills Found." />;

  return (
    <div className="container py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-light">
          <h5 className="mb-0">🧾 Payment Hostel Utils Bills</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-sm align-middle">
              <thead className="table-light text-center">
                <tr>
                  <th>SL</th>
                  <th>Tnx ID</th>
                  <th>Billing Month</th>
                  <th>Stay Days</th>
                  <th>Total Bills</th>
                  <th>Paid Status</th>
                  <th>Generated at</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {hostelBills.length > 0 ? (
                  hostelBills.map((txn, index) => (
                    <tr key={index}>
                      <td className="text-center">{index+1}</td>
                      <td className="text-center">{txn.id}</td>
                      <td className="text-center">{getYearMonthName(txn.billing_month)}</td>
                      <td className="text-center">{txn.stay_days}</td>
                      <td className="text-center">{txn.total_util_amt}</td>
                      <td className="text-center">
                      <span
                        className={`badge ${
                          txn.status ===1 ? 'bg-success' : 'bg-danger'
                        }`}
                      >
                        {txn.status === 1 ? 'Verified' : 'Pending'}
                      </span>
                      </td>
                      <td className="text-center">{formatDateTime(txn.created_at)}</td>
                      <td>
                          <button onClick={() => handleDownloadHostelUtilityReceipt(txn.id)} className="btn btn-sm btn-outline-success">
                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cloud-download-fill" viewBox="0 0 16 16">
                               <path fillRule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0m-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
                            </svg> 
                          </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HostelBills